import * as React from "react";
import { SVGProps } from "react";

const LinkIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 41 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.5386 23.6H25.7293C24.9665 23.6 24.3339 22.969 24.3339 22.208C24.3339 21.4471 24.9665 20.816 25.7293 20.816H28.5386C33.413 20.816 37.3758 16.8627 37.3758 12C37.3758 7.13731 33.413 3.18402 28.5386 3.18402H25.7479C24.9851 3.18402 24.3526 2.55298 24.3526 1.79202C24.3526 1.03106 24.9665 0.400024 25.7479 0.400024H28.5386C34.9572 0.400024 40.1665 5.59682 40.1665 12C40.1665 18.4032 34.9572 23.6 28.5386 23.6Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M14.5851 23.6H11.7944C5.37581 23.6 0.166504 18.4032 0.166504 12C0.166504 5.59682 5.37581 0.400024 11.7944 0.400024H14.5851C15.3479 0.400024 15.9805 1.03106 15.9805 1.79202C15.9805 2.55298 15.3479 3.18402 14.5851 3.18402H11.7944C6.91999 3.18402 2.9572 7.13731 2.9572 12C2.9572 16.8627 6.91999 20.816 11.7944 20.816H14.5851C15.3479 20.816 15.9805 21.4471 15.9805 22.208C15.9805 22.969 15.3479 23.6 14.5851 23.6Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M27.6084 13.392H12.7246C11.9619 13.392 11.3293 12.761 11.3293 12C11.3293 11.2391 11.9619 10.608 12.7246 10.608H27.6084C28.3712 10.608 29.0037 11.2391 29.0037 12C29.0037 12.761 28.3712 13.392 27.6084 13.392Z"
      fill="#1A1C1F"
      className={props.className}
    />
  </svg>
);

export default LinkIcon;
